import { combineReducers } from 'redux';
import { UserViewModel } from 'stageclip-common';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import * as SessionHelper from '../helpers/sessionHelper';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

const localStorageSession = SessionHelper.loadSession();
const initialUserIds = localStorageSession.user ? [localStorageSession.user.id] : [];
const initialUsers = localStorageSession.user ? { [localStorageSession.user.id]: localStorageSession.user } : {};

function allIdsReducer(state: string[] = initialUserIds, action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.AllUsersLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.UserLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.LoginSuccessful:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.ActiveEventsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.UserCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.UserEdited:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.EventEdited:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.EventCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.users);
    case InternalActionTypes.UserDeleted:
      return ReducerHelper.removeId(state, action.meta.userId);
    default:
      return state;
  }
}

function byIdReducer(state: ById<UserViewModel> = initialUsers, action: AllActions): ById<UserViewModel> {
  switch (action.type) {
    case InternalActionTypes.AllUsersLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.UserLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.LoginSuccessful:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.ActiveEventsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.UserCreated: {
      const userId = action.result.result.toLowerCase();
      const user = { ...action.result.entities.users[userId] };

      return ReducerHelper.updateItemByFunc(
        state,
        (i: UserViewModel) => {
          delete user.password;

          return { ...i, ...user };
        },
        userId,
      );
    }
    case InternalActionTypes.UserEdited:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.EventEdited:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.EventCreated:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.users);
    case InternalActionTypes.UserDeleted:
      return ReducerHelper.removeItem(state, action.meta.userId);
    default:
      return state;
  }
}

export const usersReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
